export const COMPETENCIES_BY_LANGUAGE = {
    English: [
        "Empathy",
        "Conflict Resolution",
        "Communication Skills",
        "Solution Orientation",
        "Customer Orientation",
        "Assertiveness",
        "Active Listening",
        "Questioning",
        "Conversation Steering",
        "Persuasiveness",
        "Situation Awareness",
        "Objection Handling",
        "Deal Framing",
        "Coaching Skills",
        "Constructive Feedback",
        "Goal Setting & Action Planning"
      ],
    Dutch: [
        "Empathie",
        "Conflicthantering",
        "Communicatievaardigheden",
        "Oplossingsgerichtheid",
        "Klantgerichtheid",
        "Assertiviteit",
        "Actief Luisteren",
        "Doorvragen",
        "Gesprekssturing",
        "Overtuigingskracht",
        "Contextbewustzijn",
        "Omgaan met Bezwaren",
        "Dealframing",
        "Coachingsvaardigheden",
        "Constructieve Feedback",
        "Doelstellingen en Actieplanning"
      ],
    French: [
        "Empathie",
        "Gestion des conflits",
        "Compétences en communication",
        "Orientation solution",
        "Orientation client",
        "Assertivité",
        "Écoute active",
        "Questionnement approfondi",
        "Conduite de l'entretien",
        "Force de persuasion",
        "Conscience de la situation",
        "Gestion des objections",
        "Cadrage de l'offre",
        "Compétences de coaching",
        "Feedback constructif",
        "Définition d'objectifs et planification d'actions"
      ],
};
